import { ICenter } from "./LocationFinderTypes";

const degreesToRadians = (degrees: number) => {
    return (degrees * Math.PI) / 180;
};

export const distanceInMiBetweenEarthCoordinates = (lat1Init: number, lon1: number, center: ICenter) => {
    const earthRadiusMi = 3959;
    const lat2Init = center.lat;
    const lon2 = center.lng;

    const dLat = degreesToRadians(lat2Init - lat1Init);
    const dLon = degreesToRadians(lon2 - lon1);

    const lat1 = degreesToRadians(lat1Init);
    const lat2 = degreesToRadians(lat2Init);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2) *
        Math.cos(lat1) *
        Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusMi * c;
};

export function UrlContentToDataUri(url: string): Promise<string> {
    return fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise(callback => {
            let reader = new FileReader();
            reader.onload = function () {
                callback(this.result as string)
            };
            reader.readAsDataURL(blob);
        }))
}

export async function getDrivingDirections(to: ICenter, from?: ICenter) : Promise<string> {
    let baseUrl = new URL("https://www.google.com/maps/dir/?api=1")
    baseUrl.searchParams.append("travelmode", "driving")
    baseUrl.searchParams.append("destination", `${to.lat},${to.lng}`)

    return new Promise((resolve, reject) => {
        if (from != undefined) {
            baseUrl.searchParams.append("origin", `${from.lat},${from.lng}`)
            resolve(baseUrl.toString())
        } else if (window.navigator && window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(
                (location: any) => {
                    if (location.coords) {
                        baseUrl.searchParams.append("origin", `${location.coords.latitude},${location.coords.longitude}`)
                        resolve(baseUrl.toString())
                    }

                },
                (err) => reject(err)
            );
        } else {
            reject("Impossible to get current position")
        }
    })
}
